export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-smartphone-line"></i>
              <span>移动端专属体验</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              随时随地，下拉式滚动阅读
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              下载番茄漫画 APP，享受竖屏连续流畅阅读体验。离线缓存功能让你在没有网络时也能畅快追更，
              韩漫日漫国漫随时随地想看就看。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                <span className="text-sm font-medium">App Store 下载</span>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-google-play-fill text-lg"></i>
                <span className="text-sm font-medium">Google Play 下载</span>
              </div>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-[220px] h-[400px] md:w-[260px] md:h-[480px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20vertical%20scrolling%20webtoon%20comic%20on%20screen%2C%20minimal%20clean%20phone%20frame%2C%20warm%20coral%20and%20cream%20background%2C%20modern%20app%20UI%20showing%20manga%20content%2C%20soft%20lighting%2C%20product%20photography%20style%2C%20no%20text&width=520&height=960&seq=app-mockup-01&orientation=portrait"
                alt="番茄漫画 APP 竖屏滚动阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}